
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getIndividualJobStatus = async () => {
  return await get<ApiResponse<any[]>>("/individualJobStatus").then((res)=>{
      return res
    })
};

 